import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { Ticket, TicketRecordType, TicketStatus } from 'src/app/models/ticket/ticket.model';
import { LoadTickets, LoadTicketsFail, LoadTicketsSuccess } from '../../../store';
import { ChartType } from '../../types/chart-type';
import { HorizontalBarsKpi } from '../../types';
import { ChartService } from './chart.service';

const STATES = Object.freeze([TicketStatus.Closed]);

@Injectable()
export class YtdNocCasesClosedCodeChartService extends ChartService<HorizontalBarsKpi> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadTickets,
    failure: LoadTicketsFail,
    success: LoadTicketsSuccess,
  }).pipe(
    map(({ loading, data }) => {
      type DataValue = HorizontalBarsKpi['value'];
      const dataValue: DataValue = Object?.values(
        data?.data?.reduce(
          (response: Record<string, DataValue[0]>, ticket) => {
            if (!this.filterByStatus(ticket)) return response;
            const ticketType = ticket.Close_Code__c;

            // eslint-disable-next-line no-multi-assign
            const item = (response[ticketType] ??= {
              generalLabel: ticketType || `(${TicketRecordType.Other})`,
              values: [0, 0],
            });

            item.values[1] += ticket.Time_to_Repair_Days__c || 0;
            item.values[0] += 1;

            return response;
          },
          {} as Record<string, DataValue[0]>,
        ) ?? {},
      );

      dataValue.forEach((item) => {
        item.values[1] /= item.values[0];
        item.values[1] = Number(item.values[1].toFixed(2));
      });

      dataValue.sort((a, b) => b.values[0] - a.values[0]);

      return {
        ngClass: [],
        loading,
        data: {
          type: ChartType.BARSH,
          id: 'YTD NOC cases closed code',
          title: 'YTD Closed NOC Tickets by Code',
          hyperlink: '/tickets',
          value: dataValue,
          groupsLabels: ['Ticket Count', 'RTA (Days)'],
          xAxisLabel: 'Ticket Count / RTA (Days)',
        } satisfies HorizontalBarsKpi,
      };
    }),
  );

  private filterByStatus(ticket: Ticket): boolean {
    return STATES.includes(ticket.Status);
  }
}
